export default __webpack_public_path__ + "static/media/icon-cake-1.214ce494.svg";